import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import {
  HtmlContent,
  HtmlContentWithIframe,
} from 'hb-react/shared/components/HtmlContent';

const PublicationText = ({ text, noIframes = false, ...props }) => (
  <Wrapper {...props}>
    {noIframes ? (
      <HtmlContent content={text} stylesConfig="web" enableImagePreview />
    ) : (
      <HtmlContentWithIframe
        content={text}
        stylesConfig="web"
        enableImagePreview
      />
    )}
  </Wrapper>
);

export default PublicationText;

const Wrapper = styled(Box).attrs({
  display: 'block',
  width: '100%',
})`
  // clearfix
  &:after {
    content: '';
    clear: both;
    display: table;
  }
`;
